<template>
    <div class="document-share-buttons">
        <!-- <ShareNetwork
            network="linkedin"
            :url="url"
            title="SmartCertificate"
            @open="onShareNetworkOpen"
            @change="onShareNetworkChange"
            @close="onShareNetworkClose"
            >
            <RingButton class="document-share-buttons-linkedin"><icon src="sharing-icon-linkedin" class="hover-bounce"/></RingButton>
        </ShareNetwork> -->
        <RingButton
            class="document-share-buttons-linkedin"
            @click="onLinkedInShareClick"
        >
            <icon src="sharing-icon-linkedin" class="hover-bounce"/>
        </RingButton>
        <ShareNetwork
            network="facebook"
            :url="url"
            title="SmartCertificate"
            @open="onShareNetworkOpen"
            @change="onShareNetworkChange"
            @close="onShareNetworkClose"
            >
            <RingButton class="document-share-buttons-facebook"><icon src="sharing-icon-facebook" class="hover-bounce"/></RingButton>
        </ShareNetwork>
        <ShareNetwork
            network="twitter"
            :url="url"
            title="SmartCertificate"
            @open="onShareNetworkOpen"
            @change="onShareNetworkChange"
            @close="onShareNetworkClose"
            >
            <RingButton class="document-share-buttons-twitter"><icon src="sharing-icon-twitter" class="hover-bounce"/></RingButton>
        </ShareNetwork>
        <ShareNetwork
            network="whatsapp"
            :url="url"
            title="SmartCertificate"
            @open="onShareNetworkOpen"
            @change="onShareNetworkChange"
            @close="onShareNetworkClose"
            >
            <RingButton class="document-share-buttons-whatsapp"><icon src="sharing-icon-whatsapp" class="hover-bounce"/></RingButton>
        </ShareNetwork>
        <ShareNetwork
            network="email"
            :url="url"
            title="SmartCertificate"
            @open="onShareNetworkOpen"
            @change="onShareNetworkChange"
            @close="onShareNetworkClose"
            >
            <RingButton class="document-share-buttons-email"><icon src="sharing-icon-envelope-o" class="hover-bounce"/></RingButton>
        </ShareNetwork>
        <!-- <RingButton class="document-share-buttons-clipboard"><icon src="sharing-icon-clipboard" class="hover-bounce"/></RingButton> -->
    </div>
</template>

<script>
import { ShareNetwork } from 'vue-social-sharing'
import RingButton from '@/components/v3/buttons/RingButton.vue'
import Icon from '@/components/commons/icon/Icon.vue'
// import { UserDocumentActivityEnum } from '@/services/api/UserDocumentApiService'

export default {
    components: {
        ShareNetwork,
        RingButton,
        Icon
    },
    props: {
        urlToShare: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            gaPageName: '/user-document',
            url: this.urlToShare || window.location.href
        }
    },
    methods: {
        onLinkedInShareClick () {
            window.open('https://www.linkedin.com/shareArticle?url=' + encodeURIComponent(this.url), 'LinkedIn', 'width=626,height=436')
            this.onShareNetworkOpen('linkedin', this.url)
        },
        onShareNetworkOpen (network, url) {
            this.$ga.event(this.gaPageName, 'share-open', network, 0)
            console.log('onShareNetworkOpen', network)
            switch (network) {
                case 'linkedin':
                    // this.$emit('networkOpen', UserDocumentActivityEnum.LinkedinClick)
                    break
                case 'facebook':
                    // this.$emit('networkOpen', UserDocumentActivityEnum.FacebookClick)
                    break
                case 'whatsapp':
                    // this.$emit('networkOpen', UserDocumentActivityEnum.WhatsAppClick)
                    break
                case 'email':
                    // this.$emit('networkOpen', UserDocumentActivityEnum.EmailClick)
                    break
                case 'twitter':
                    // this.$emit('networkOpen', UserDocumentActivityEnum.TwitterClick)
                    break
                default:
                    break
            }
        },
        onShareNetworkChange (network, url) {
            this.$ga.event(this.gaPageName, 'share-change', network, 0)
        },
        onShareNetworkClose (network, url) {
            this.$ga.event(this.gaPageName, 'share-close', network, 0)
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$content-lighter = 50

.document-share-buttons
    display flex
    gap 4px
    flex-direction row

    .ring-button

        .icon
            font-size 18px

    &.boxed

        .ring-button
            width 54px !important
            height 54px !important
            border-radius 5px !important

            .ring-button-content
                border-radius 5px !important

            .icon
                font-size 24px

    > :not(:first-child)
        margin-left 4px

    &.vertical
        flex-direction column

        > :not(:first-child)
            margin-left 0
        > :not(:last-child)
            margin-bottom 4px

        .ring-button
            width 44px
            height 44px

    .ring-button
        background-color transparent

        .ring-button-content
            box-shadow 2px 2px 2px rgba(0, 0, 0, 0.2)

            .icon
                transition color 0.75s cubic-bezier(0.270, 1.650, 0.500, 1.000)

    .document-share-buttons-facebook .ring-button-content
        background-color #1877f2 !important
        &:hover
            // background-color lighten(#1877f2, $content-lighter) !important
            background-color white !important
            .icon
                color #1877f2

    .document-share-buttons-linkedin .ring-button-content
        background-color #0a66c2 !important
        &:hover
            // background-color lighten(#0a66c2, $content-lighter) !important
            background-color white !important
            .icon
                color #0a66c2

    .document-share-buttons-twitter .ring-button-content
        background-color #1da1f2 !important
        &:hover
            // background-color lighten(#1da1f2, $content-lighter) !important
            background-color white !important
            .icon
                color #1da1f2

    .document-share-buttons-email .ring-button-content
        background-color #35465d !important
        &:hover
            // background-color lighten(#35465d, $content-lighter) !important
            background-color white !important
            .icon
                color #35465d

    .document-share-buttons-whatsapp .ring-button-content
        background-color #25d366 !important
        &:hover
            // background-color lighten(#25d366, $content-lighter) !important
            background-color white !important
            .icon
                color #25d366

    .document-share-buttons-clipboard .ring-button-content
        background-color #35465d !important
        &:hover
            // background-color lighten(#35465d, $content-lighter) !important
            background-color white !important
            .icon
                color #35465d
</style>


// WEBPACK FOOTER //
// src/modules/documents/components/PublicDocumentShareButtons.vue